import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import LetEngineersFocusedImage from './LetEngineersFocusedImage'

const copy = {
  heading: `Let your engineers focus on product, not integrations`,
  description: `Building and maintaining integrations take a lot of developer time. Segment makes it easy. Instrument your analytics once, and integrate with ${process.env.INTEGRATION_COUNT}+ tools in just a few minutes.`,
}

const StreamlineYourRegulatoryCompliance = () => (
  <SectionBase variant="2Col">
    <SectionCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Heading>{copy.heading}</CopyText.Heading>
        <CopyText.Description>{copy.description}</CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <LetEngineersFocusedImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default StreamlineYourRegulatoryCompliance
